import React from "react";

const Precontrattuale = () => {
  return <div>Precontrattuale</div>;
};

export default Precontrattuale;
